(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[455],{

/***/ 7264:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-us",
      function () {
        return __webpack_require__(5506);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5506:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Support": function() { return /* binding */ Support; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_node_modules_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8520);
/* harmony import */ var _vercel_path0_node_modules_next_node_modules_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_node_modules_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5675);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9008);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1955);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7294);
/* harmony import */ var contexts_app_context__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6777);
/* harmony import */ var components_app_header__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9735);
/* harmony import */ var components_app_footer__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2695);
/* harmony import */ var components_modals_modal_message__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(3913);
/* harmony import */ var components_modals_modal_join_outing__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(8049);
/* harmony import */ var styles_support_module_scss__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(6903);
/* harmony import */ var styles_support_module_scss__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(styles_support_module_scss__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var utils_apiHandler__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(6970);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(3135);















function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
var Support = function() {
    var ref5 = _slicedToArray((0,contexts_app_context__WEBPACK_IMPORTED_MODULE_7__/* .useAppContext */ .b)(), 2), state = ref5[0], dispatch = ref5[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(''), email1 = ref1[0], setEmail = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(''), code = ref2[0], setCode = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(''), issue1 = ref3[0], setIssue = ref3[1];
    var submitRequest = _asyncToGenerator(_vercel_path0_node_modules_next_node_modules_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var jwtToken, messagePayload, ref, ref4;
        return _vercel_path0_node_modules_next_node_modules_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (validateForm({
                        email: email1,
                        issue: issue1
                    })) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 2:
                    _ctx.prev = 2;
                    jwtToken = js_cookie__WEBPACK_IMPORTED_MODULE_5__/* ["default"].get */ .Z.get('jwtToken');
                    _ctx.next = 6;
                    return axios__WEBPACK_IMPORTED_MODULE_4___default().post("".concat("https://api.teamgames.gg", "/support/submit-request"), {
                        email: email1,
                        code: code,
                        issue: issue1
                    }, {
                        headers: {
                            Authorization: "Bearer ".concat(jwtToken)
                        }
                    });
                case 6:
                    messagePayload = {
                        additional: {
                            messageTitle: 'Confirmation',
                            message: 'Thanks for using Team Games. We will get back to you within 1 business day.',
                            btnClose: 'Return'
                        }
                    };
                    dispatch({
                        type: 'SET_ALERT_MESSAGE',
                        payload: messagePayload
                    });
                    dispatch({
                        type: 'SHOW_MODAL_MESSAGE',
                        payload: true
                    });
                    _ctx.next = 16;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](2);
                    ;
                    if ((_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref = _ctx.t0.response) === null || ref === void 0 ? void 0 : (ref4 = ref.data) === null || ref4 === void 0 ? void 0 : ref4.msg) === 'Invalid input: {"email":["The email must be a valid email address."]}') _ctx.t0.response.data.msg = 'Please enter a valid email address';
                    (0,utils_apiHandler__WEBPACK_IMPORTED_MODULE_12__/* .apiResponseErrorHandler */ .A)({
                        error: _ctx.t0,
                        dispatch: dispatch
                    });
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                2,
                11
            ]
        ]);
    }));
    var validateForm = function(param) {
        var email = param.email, issue = param.issue;
        var message = '';
        if (!email) {
            message = 'Your Email Address should not be empty';
        }
        if (!issue) {
            message = 'Please enter the Issue you’re having';
        }
        if (message) {
            dispatch({
                type: 'SET_ALERT_MESSAGE',
                payload: message
            });
            dispatch({
                type: 'SHOW_MODAL_MESSAGE',
                payload: true
            });
            return false;
        }
        return true;
    };
    var handleChangeEmail = function(event) {
        var newEmail = event.target.value.slice(0, 50);
        setEmail(newEmail);
    };
    var handleChangeCode = function(event) {
        var newCode = event.target.value.slice(0, 25);
        setCode(newCode);
    };
    var handleChangeIssue = function(event) {
        setIssue(event.target.value);
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: (styles_support_module_scss__WEBPACK_IMPORTED_MODULE_14___default().support_page),
        id: "support_page",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(next_head__WEBPACK_IMPORTED_MODULE_3__["default"], {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
                        children: "Contact Us | Team Games"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
                        rel: "icon",
                        href: "/images/modal_logo.png"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        name: "description",
                        content: utils_constants__WEBPACK_IMPORTED_MODULE_13__/* .TeamGamesMetaDescription */ .iO
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        name: "og:image",
                        content: utils_constants__WEBPACK_IMPORTED_MODULE_13__/* .TeamGamesOGImagePath */ .Od
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: (styles_support_module_scss__WEBPACK_IMPORTED_MODULE_14___default().header_section),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_app_header__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        transparent: true
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: (styles_support_module_scss__WEBPACK_IMPORTED_MODULE_14___default().header_bg),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: (styles_support_module_scss__WEBPACK_IMPORTED_MODULE_14___default().header_bg_img),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                src: "/images/contact/header.png",
                                alt: "We'd love to hear from you",
                                layout: "fill"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: (styles_support_module_scss__WEBPACK_IMPORTED_MODULE_14___default().content_bg),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: (styles_support_module_scss__WEBPACK_IMPORTED_MODULE_14___default().content_bg_img),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                    src: "/images/contact/main_bg.png",
                                    alt: "Contact Page Main Background",
                                    layout: "fill"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: (styles_support_module_scss__WEBPACK_IMPORTED_MODULE_14___default().support_woman),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                    src: "/images/contact/support_woman.png",
                                    alt: "Support Woman Image",
                                    width: 635,
                                    height: 327
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: (styles_support_module_scss__WEBPACK_IMPORTED_MODULE_14___default().support_container),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: (styles_support_module_scss__WEBPACK_IMPORTED_MODULE_14___default().support_context),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
                                className: "hero ".concat((styles_support_module_scss__WEBPACK_IMPORTED_MODULE_14___default().title)),
                                children: "We'd love to hear from you"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "description_large ".concat((styles_support_module_scss__WEBPACK_IMPORTED_MODULE_14___default().description)),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                    children: "Feel like contacting us? Submit your queries here and we will get back to you as soon as possible."
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: (styles_support_module_scss__WEBPACK_IMPORTED_MODULE_14___default().support_form),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                                    className: "heading_2 ".concat((styles_support_module_scss__WEBPACK_IMPORTED_MODULE_14___default().support_title)),
                                    children: "Contact Us"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: (styles_support_module_scss__WEBPACK_IMPORTED_MODULE_14___default().support_label),
                                children: "Email Address"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                className: (styles_support_module_scss__WEBPACK_IMPORTED_MODULE_14___default().support_input),
                                type: "text",
                                placeholder: "Enter Your Email",
                                value: email1,
                                onChange: handleChangeEmail
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: (styles_support_module_scss__WEBPACK_IMPORTED_MODULE_14___default().support_label),
                                children: "Outing URL or Outing code"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                className: (styles_support_module_scss__WEBPACK_IMPORTED_MODULE_14___default().support_input),
                                type: "text",
                                placeholder: "Enter Outing URL Or Passcode Here",
                                value: code,
                                onChange: handleChangeCode
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: (styles_support_module_scss__WEBPACK_IMPORTED_MODULE_14___default().support_label),
                                children: "Describe the Issue you’re having"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("textarea", {
                                className: (styles_support_module_scss__WEBPACK_IMPORTED_MODULE_14___default().support_textarea),
                                rows: 10,
                                maxLength: 1000,
                                placeholder: "Description",
                                value: issue1,
                                onChange: handleChangeIssue
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: (styles_support_module_scss__WEBPACK_IMPORTED_MODULE_14___default().support_action),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: (styles_support_module_scss__WEBPACK_IMPORTED_MODULE_14___default().support_action_submit),
                                    onClick: submitRequest,
                                    children: "Submit"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_modals_modal_message__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_modals_modal_join_outing__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_app_footer__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (Support);


/***/ }),

/***/ 6970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ apiResponseErrorHandler; }
/* harmony export */ });
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);

var apiResponseErrorHandler = function(param) {
    var error = param.error, dispatch = param.dispatch, _fallback = param.fallback, fallback = _fallback === void 0 ? null : _fallback;
    var status = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(error, 'response.status');
    var message = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(error, 'response.data.msg', 'Something went wrong!');
    if (fallback && typeof fallback === 'function') {
        fallback(message);
        return;
    }
    if (!dispatch) return;
    var payload = message;
    if (payload === 'Invalid input: {"passcode":["The passcode field is required."]}') payload = 'Enter a passcode to join an Outing';
    else if (status === 419) {
        payload = {
            additional: {
                message: "The session has expired. Please close the app by clicking the three dots (...) above and selecting \"Close\" and launch the app again",
                btnClose: 'Continue'
            }
        };
    }
    dispatch({
        type: 'SET_ALERT_MESSAGE',
        payload: payload
    });
    dispatch({
        type: 'SHOW_MODAL_MESSAGE',
        payload: true
    });
};


/***/ }),

/***/ 6903:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"support_page":"support_support_page__woFRq","header_bg":"support_header_bg__C7zYA","header_bg_img":"support_header_bg_img__Ng_Kv","content_bg":"support_content_bg__fsvsz","content_bg_img":"support_content_bg_img__VneuX","support_woman":"support_support_woman__uT2X5","support_context":"support_support_context__JYJqA","title":"support_title__yynq_","description":"support_description__5tWD3","support_container":"support_support_container__j9nuh","support_form":"support_support_form__jZgIN","support_title":"support_support_title___0gDm","support_label":"support_support_label__Z0I__","support_input":"support_support_input__NAJb1","support_textarea":"support_support_textarea__0Lujr","support_action":"support_support_action__OU9zW","support_action_cancel":"support_support_action_cancel__OwHIr","support_action_submit":"support_support_action_submit__ybtuM"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [78,673,774,888,179], function() { return __webpack_exec__(7264); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);